// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17-YX","col":"styles_col__V-ZIe"};